<template>
<span :id="id" aria-hidden="true" class="anchor-id"></span>
</template>

<script>
export default {

    props: ['data'],
    
    setup(props) {
        return {
            id: props.data.id
        }
    }

}
</script>